import moment from 'moment';

// const cellPadding = 7.5 * 2;

// eslint-disable-next-line import/prefer-default-export
export class GridHelper {
  static defaultGridOptions = {
    defaultColDef: {},
    headerHeight: 45,
    icons: {
      menu: '<svg width="10" height="8"><rect y="0" width="10" height="2" class="ag-header-icon"></rect><rect y="3" width="10" height="2" class="ag-header-icon"></rect><rect y="6" width="10" height="2" class="ag-header-icon"></rect></svg>',
      filter: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><polygon class="ag-header-icon" points="0,0 4,4 4,10 6,10 6,4 10,0" /></svg>',
      sortAscending: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><polygon points="0,0 5,10 10,0" /></svg>',
      sortDescending: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><polygon points="0,10 5,0 10,10" /></svg>'
    },
    overlayLoadingTemplate: `
      <div class="sk-folding-cube">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    `,
    rowHeight: 32,
    suppressCellFocus: true,
    suppressMovableColumns: true,
    suppressTouch: true,
    cacheQuickFilter: true,
    pagination: true,
    paginationPageSize: 50
  };

  static pageNavigationSteps = { first: 'first', last: 'last', next: 'next', previous: 'previous' };

  static buildGridOptions(gridOptions = {}) {
    return {
      ...GridHelper.defaultGridOptions,
      ...gridOptions
    };
  }

  static dateFormatter(value, format) {
    if (!value) {
      return 'NA';
    }
    return moment(value).format(format);
  }

  static sizeColumnsToFit(gridApi) {
    if (!gridApi) {
      return console.error('GridHelper -> setSizeToFit: gridApi is not initialized');
    }
    return setImmediate(() => gridApi.sizeColumnsToFit(), 0);
  }

  static resetRowHeights(gridApi) {
    if (!gridApi) {
      return console.error('GridHelper -> resetRowHeights: gridApi is not initialized');
    }
    return setImmediate(() => gridApi.resetRowHeights(), 0);
  }

  static calculateRowHeight({ id: rowIndex }) {
    const rowNodeSelector = `.ag-body-viewport .ag-row[row-id="${ rowIndex }"] div.ag-cell`;
    const cells = document.querySelectorAll(rowNodeSelector);
    if (cells != null) {
      let max = GridHelper.defaultGridOptions.rowHeight;
      Array.from(cells).forEach((cell) => {
        if (cell != null) {
          // const cont = cell.querySelector('.ag-cell.ag-cell-value');
          // if (cont != null) {
          max = Math.max(max, cell.clientHeight);
          // }
        }
      });
      return max;
    }
    return GridHelper.defaultGridOptions.rowHeight;
  }
}
